<template>
<div class="ui_rightInfoBox" v-if="isShow" @click.stop="hide">
  <div class="rightInfoBox">
    <div class="titleBox">
      <p class="titile">{{ title }}</p>
      <i class="icon iconfont iconshangwuguanbi" @click.stop="hide"></i>
    </div>
    <div class="titleInfo" v-html="info">

    </div>
  </div>
</div>
</template>
<script>
import { getStorage } from "@/utils/wxuser";

var config = {};
export default {
  data() {
    return {
      isShow: false
    };
  },
  props: ["title", "info"],
  components: {},

  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
  },

  created() {
    config = getStorage("config");
  },
  mounted() {

  },
  beforeDestroy() { },
  computed: {}
};
</script>
<style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/skin.less");
@import url("~@/styles/mixin.less");

.ui_rightInfoBox {
  width: 100vw;
  height: 100vh;
  z-index: 99;
  background: rgba(0, 0, 0, 0.51);
  position: fixed;
  top: 0;
  left: 0;

  .rightInfoBox {
    width: 315px;
    min-height: 145px;
    background: #FFFFFF;
    border-radius: 10px;
    left: calc(~"(100vw - 315px) / 2");
    top: 150px;
    z-index: 100;
    position: absolute;

    .titleBox {
      height: 54px;
      position: relative;
      font-size: 17px;
      color: #333333;
      text-align: center;

      .titile {
        line-height: 54px;
        font-weight: bold;
      }

      .iconfont {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 11px;
      }
    }

    .titleInfo {
      padding: 10px 20px 20px 20px;
      font-size: 15px;
      color: #666666;
      line-height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightInfoBox.vue